export const NONCE_POOL_EXPIRATION_TIME = 60000 * 60 * 24;

export const NONCE_POOL_SIZE = 5;
